export const anggaranPemasukanFormData = (
  dropdownUnitUsaha,
  dropdownAkuns,
  dropdownTahun
) => {
  return [
    {
      id: "id_unit_usaha",
      label: "Pilih Unit Usaha",
      fields: [
        {
          type: "option",
          options: dropdownUnitUsaha,
        },
      ],
    },
    {
      id: "id_sistem_akun",
      label: "Pilih kode akun",
      fields: [
        {
          type: "option",
          options: dropdownAkuns,
        },
      ],
    },
    {
      id: "nama_anggaran_pemasukan",
      label: "Nama Anggaran Pemasukan",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Nama Anggaran Pemasukan...",
        },
      ],
    },
    {
      id: "jumlah_anggaran_pemasukan",
      label: "Jumlah Anggaran Pemasukan",
      fields: [
        {
          type: "input",
          placeholder: "Masukan Jumlah Anggaran Pemasukan...",
        },
      ],
    },
    {
      id: "tahun_anggaran_pemasukan",
      label: "Tahun Anggaran Pemasukan",
      fields: [
        {
          type: "option",
          options: dropdownTahun,
        },
      ],
    },
  ];
};
